// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// ImportCipNumbersHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    selectedFile: any | null;
    installedTermId: string | null;
    installedYear: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            selectedFile: null,
            installedTermId: '00000000-0000-0000-0000-000000000000',
            installedYear: 0,
        },
        initValues);
    },
    selectedFile: 'selectedFile',
    installedTermId: 'installedTermId',
    installedYear: 'installedYear',
}

interface Result extends ResultDTO {
    message: string | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            message: "",
        },
        initValues);
    },
    message: 'message',
}

export { Request, Result };